/*
 * Validate-address.ts
 * Description: Includes the declaration of a function
 * for validating address data before sending a request
 */

// Importing variables
import {
    MissingFirstName, MissingPhone, PhoneInvalid,
    PhoneRegex, TooLongFirstName, TooLongPhone,
    MissingTown, MissingAddress,
} from '@/ts/variables';

export interface Address {
    name: string;
    phone: string;
    address: string;
    town_ekatte: string;
}

/**
 * Checking if address data is valid before sending the request
 *
 * @param {String[]} errors - register errors
 * @param {Address} data - address data
 */
export function validateAddress(errors: string[], data: Address) {
    // Validating first name
    if (data.name.length === 0) { errors.push(MissingFirstName); }
    if (data.name.length > 255) { errors.push(TooLongFirstName); }

    // Validating phone
    if (data.phone.length === 0) { errors.push(MissingPhone); }
    if (!PhoneRegex.test(data.phone)) { errors.push(PhoneInvalid); }
    if (data.phone.length > 255) { errors.push(TooLongPhone); }

    // Validating town ekatte
    if (data.town_ekatte.length === 0) { errors.push(MissingTown); }

    // Validating address
    if (data.address.length === 0) { errors.push(MissingAddress); }
}
